import { http } from '../core/request';
import { ApiUrls } from '../endpoints/apiUrls';
import { HealthCheckResult } from '../types/common';

/**
 * 系统相关API服务
 * 包含系统健康检查等功能
 */
export class SystemService {
  /**
   * 系统健康检查
   * @returns Promise<HealthCheckResult> 健康检查结果
   */
  static async healthCheck(): Promise<HealthCheckResult> {
    return await http.get<HealthCheckResult>(ApiUrls.SYSTEM.HEALTH_CHECK, {}, {
      showLoading: false, // 健康检查不显示loading
      showError: false, // 健康检查失败不显示错误提示
    });
  }
}
